<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Currencies</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6">
            <v-btn color="accent" small to="/new-currency">
              <v-icon left dark>mdi-plus</v-icon> New Currency
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="currencies"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/currency/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loader: false,
    zeroValue: 0,
    pageItems: 100,
    date: null,
    headers: [
      { text: "Customer Name", value: "Name" },
      { text: "Kshs Conversion", value: "ConversionRate" },
      { text: "Symbol", value: "Symbol" },
      { text: "Action", value: "action" },
    ],
    currencies: [],
    excelFile: null,
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    getCurrencies() {
      const self = this;
      this.$store
        .dispatch("get", `/currencies`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.currencies = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getCurrencies();
  },
};
</script>